import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { MenuListItem } from '@fcom/common/interfaces';

import { IconPosition } from '../../icons';
import { MenuListClickEvent } from '../interfaces';

@Component({
  selector: 'fcom-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrl: './menu-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MenuListComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  items = input.required<MenuListItem[]>();
  itemClicked = output<MenuListClickEvent>();

  handleClick(itemId: string, event: Event): void {
    this.itemClicked.emit({
      itemId,
      originalEvent: event,
    });
  }

  protected readonly IconPosition = IconPosition;
}
